// eslint-disable-next-line import/prefer-default-export
export const base64ToString = (base64: string): string =>
  Buffer.from(base64, 'base64').toString();

export const stringToBase64 = (input: string): string =>
  Buffer.from(input).toString('base64');
